// extracted by mini-css-extract-plugin
export default {"values":"Values_values__RcU0o","values__title":"Values_values__title__xNe+z"};